{
	"404": {
		"this-screen-doesnt-exist": "This screen doesn't exist",
		"go-to-home-screen": "Go to home screen"
	},
	"flag": "🇺🇸",
	"org-interpolations": {
		"default": {
			"caregivers": "Caregivers",
			"caregiver": "Caregiver",
			"care-recipients": "Care Recipients",
			"care-recipient": "Care Recipient"
		},
		"education": {
			"caregivers": "Teachers",
			"caregiver": "Teacher",
			"care-recipients": "Students",
			"care-recipient": "Student"
		}
	},
	"common": {
		"yes": "Yes",
		"no": "No",
		"password": "Password",
		"e-mail": "E-mail",
		"edit": "Edit",
		"add": "Add",
		"selected": "Selected",
		"select": "Select",
		"select-all": "Select all",
		"selected-all": "Selected all",
		"sign-out": "Log out",
		"or": "Or",
		"create": "Create",
		"save": "Save",
		"language": "Language",
		"saving": "Saving",
		"delete": "Delete",
		"next": "Next",
		"get-started": "Get Started",
		"skip": "Skip",
		"optional": "Optional",
		"read-more": "Read more",
		"show-less": "Show less",
		"cancel": "Cancel",
		"search": "Search",
		"send": "Send",
		"done": "Done",
		"password-requirements-hint": "Min {{minLength}} characters, one number, one special character",
		"view-all": "View all",
		"back": "Back",
		"steps-of-total": "{{completed}} of {{total}}",
		"more": "More",
		"beta": "beta",
		"block": "Block",
		"ok": "Ok"
	},
	"post": {
		"see-all-comments": "See all comments",
		"delete-post": "Delete post",
		"are-you-sure-you-want-to-delete-this-post": "Are you sure you want to delete this post?",
		"likes": "Likes",
		"new": {
			"saving-post": "Publishing",
			"your-post-is-being-published": "Your post is being published...",
			"permission-to-access-camera-roll-is-required": "We need your permission to access the camera roll",
			"edit-post": "Edit post",
			"create-new-post": "Create a new post",
			"add-text": "Add text",
			"post-privacy": "Post privacy",
			"add-users": "Add users",
			"and-others_one": "and {{count}} other",
			"and-others_other": "and {{count}} others",
			"publish": "Publish",
			"publication-settings": "Publication settings",
			"save-settings": "Save settings",
			"search-care-recipients": "Search {{care-recipients}}",
			"your-care-recipients": "Your {{care-recipients}}",
			"errors": {
				"privacy": "Select at least one {{care-recipient}}",
				"content-media-required": "Text or media required"
			},
			"info": {
				"post-submitted-for-review": "Your post has been submitted for review",
				"post-edited-and-resubmited-for-review": "The post has been edited and resubmitted for review"
			},
			"your-teams": "Your teams",
			"organisation": "Organization",
			"all-employees": "All {{caregivers}}",
			"select": "Select",
			"team": "Team ({{ count }})",
			"blur-faces": {
				"care-receiver-reference-photo": "Care receiver reference photo",
				"add-a-photo-of-the-care-recipients-face-that-is-not-to-be-blured-out": "Add a photo of the {{care-recipient}}'s face that is not to be blured out.",
				"blur-faces-in-photos": "Blur faces in photos ({{ count }})",
				"previous-photo": "Previous photo",
				"next-photo": "Next photo",
				"blur-all": "Blur all"
			},
			"schedule-for-later": "Schedule for later",
			"to-be-published": "To be published",
			"date": "Date",
			"time": "Time",
			"show-scheduled-posts": "View all scheduled posts",
			"restrict-visibility-checkbox": "Restrict visibility to Professional Caregivers only"
		},
		"users-publications": "user’s publications",
		"post": "Post",
		"comments": "Comments",
		"add-a-comment": "Add a comment",
		"selected-users": "Selected users",
		"comment-actions": "Comment actions",
		"delete-comment-title": "Delete comment?",
		"delete-comment-content": "Are you sure you want to delete this comment?",
		"editing-comment": "Editing comment",
		"pin-post": "Pin post",
		"unpin-post": "Unpin post",
		"pinned-post": "Pinned post",
		"welcome-post": {
			"swipe-left-to-learn-more": "Swipe left to learn more about Pletly.",
			"get-to-know-care-receivers": "Get to know your {{care-recipients}}",
			"pletly-pal-offers-custom-made-biography": "Pletly offers a custom made biography of all your {{care-recipients}}.",
			"information-library": "Information library",
			"you-can-easily-structure-necessary-information": "You can easily structure necessary information about a {{care-recipient}}. This could be videos of sign language or physical exercises.",
			"welcome-to-pletly": "Welcome to Pletly!",
			"content": "Thank you for joining Pletly! We’re excited to welcome you to our platform, where we strive to improve the quality of care and enhance lives by fostering closer connections within the care circle and promoting person-centric care.",
			"social-feed-content": "Gain meaningful insights into the daily life of the {{care-recipient}} through our social feed, all while maintaining their privacy.",
			"social-feed-title": "Private and secure social feed"
		},
		"report-post": "Report post",
		"block-user": "Block user",
		"report-sent": "Report sent",
		"we-will-review-your-report-shortly": "We will review your report shortly",
		"user-blocked": "User blocked",
		"are-you-sure-to-report-this-post": "Are you sure you want to report this post?",
		"this-will-hide-it-for-you-and-report-the-post-to-the-moderators": "This will hide it for you and report the post to the moderators.",
		"are-you-sure-to-block-author-user": "Are you sure you want to block the user {{user}}?",
		"you-will-not-see-content-from-this-user-anymore": "You will no longer see content from this user.",
		"adding-media_zero": "Adding media...",
		"adding-media": "Adding media({{ count }})...",
		"book-post": {
			"new-book": "New Book"
		},
		"add-media": "Add media",
		"post-deleted": "Post deleted",
		"review": {
			"approve": "Approve",
			"reject": "Reject",
			"edit": "Edit",
			"discard": "Discard",
			"confirm-reject-modal": {
				"title": "Are you sure you want to reject {{authorName}}'s post?",
				"content": "Please provide a reason for rejecting the post.",
				"reason-field-label": "Reason",
				"reason-field-placeholder": "Enter the reason for rejection here"
			},
			"posts-to-review-screen": {
				"title": "Posts approval",
				"subtitle": "Posts waiting to be approved"
			},
			"status": {
				"pending": "Pending",
				"rejected": "Rejected",
				"approved": "Approved"
			},
			"review-submitted-successfully": "Review submitted successfully",
			"posts-submitted-screen": {
				"title": "Posts approval",
				"subtitle": "Posts waiting to be approved.",
				"reason": "Reason"
			},
			"menu": {
				"posts-to-review": "Posts to review",
				"posts-under-review": "Posts under review"
			}
		},
		"share": {
			"share": "Share",
			"share-post": "Share post",
			"shared-post": "Shared post",
			"shared-with": "Shared with {{ name }}",
			"someone-shared-post": "{{ authorName }} has shared something important with you. Click here to check it out.",
			"post-has-been-sent-in-a-chat-message": "Post has been sent via chat message"
		},
		"admin": "Admin",
		"errors": {
			"forbidden": {
				"title": "Access Denied: Unauthorized Access",
				"message": "\nIt seems you cannot access this content because you are not connected to the relevant {{care-recipient}}. This restriction is in place to safeguard the privacy of sensitive information.\n\n If you think this is an error, please review your connections or contact the person who shared the post for further assistance."
			}
		},
		"blur-faces": "Blur faces",
		"accept": "Accept",
		"add-file": "Add file",
		"delete-file": "Delete file",
		"are-you-sure-you-want-to-delete": "Are you sure you want to delete {{ name }}?",
		"file-deleted": "File deleted",
		"file-has-been-deleted-successfully": "{{ name }} has been deleted successfully.",
		"filters": {
			"btn-show": "Show filters",
			"btn-reset": "Reset filters",
			"modal": {
				"title": "Filters",
				"published-in": {
					"label": "Date of publication",
					"custom-label": "Custom period",
					"custom-placeholder": "Select custom period",
					"option-days_one": "Last day",
					"option-days_other": "Last {{count}} days",
					"option-all-time": "All time"
				},
				"care-recipients": {
					"label": "{{care-recipients}}",
					"no-care-recipients-to-select": "No {{care-recipients}} to select",
					"everyone": "Everyone",
					"selected-only": "Selected only"
				},
				"tags": {
					"label": "Tags",
					"no-tags-selected": "No tags selected",
					"available-tags": "Available tags",
					"no-tags-available": "No tags available"
				}
			}
		},
		"scheduled-posts": "Scheduled posts",
		"no-posts-scheduled": "No posts scheduled",
		"publication-error-warning": "This post failed to publish. Please review your post and try again."
	},
	"connections": {
		"create-care-receiver": "Create a {{care-recipient}}",
		"connect-to-care-receiver": "Connect to a {{care-recipient}}",
		"connect-new-care-receiver": "Connect a new {{care-recipient}}",
		"choose-how-you-want-to-connect-care-receiver": "Choose your preferred method to connect with a {{care-recipient}}. You can either create a new account or link to an existing one",
		"oops-kinda-quiet-here": "Oops! It's kinda quiet here",
		"to-be-able-to-use-pletly-pal-as-intended-and-see-resourcename-you-have-to-be-connected-to-one-or-more-users": "To use Pletly Pal as intended and view {{resourceName}}, you need to be connected to one or more users.",
		"connections": "Connections",
		"enter-the-information-about-user-to-bind-account-to-pletly-pal": "Please enter the unique username of the {{care-recipient}} to send a connection request.",
		"connect": "Connect",
		"enter-the-information-about-user-to-create-account-in-pletly-pal": "Enter the requested information to create an account for the {{care-recipient}}. You will be designated as the owner of the created account",
		"remove-name": "Remove {{name}}",
		"are-you-sure-you-want-to-remove-name-from-connections": "Are you sure you want to remove {{name}} from  your connections list?",
		"invites-of-your-proteges": "Invites for your {{care-recipient}}",
		"tab-users": "Users",
		"tab-groups": "Groups",
		"users-count_one": "{{count}} user",
		"users-count_other": "{{count}} users",
		"my-connections": "My connections",
		"create-group": "Create a group",
		"name-group": "Name group",
		"edit-group-name": "Edit group name",
		"delete-group": "Delete group",
		"are-you-sure-you-want-delete-group": "Are you sure you want to delete {{name}} group?",
		"remove-user": "Remove user",
		"are-you-sure-you-want-remove-from-group": "Are you sure you want to remove {{name}} from this group?",
		"add-friends-to-view-post": "Your caregiving journey begins with making a connection. Connect to an existing {{care-recipient}} or introduce a new one to the world of Pletly.",
		"create-care-receiver-account": "Create a {{care-recipient}} account",
		"sent-invites": "Sent invites",
		"who-sent-invite": "{{who}} sent invite",
		"connection-request-successfully-sent": "Connection request sent successfully",
		"new-request": "New request",
		"new-invitation": "New invitation",
		"create-another-care-recipient": "Create another {{care-recipient}}",
		"created-account-successfully-for": "You have successfully created an account for {{name}}",
		"you-can-invite-others-to-connect-to": "You can invite others to connect to {{name}} as {{caregivers}} or create another {{care-recipient}} account.",
		"invite-caregivers": "Invite {{caregivers}}",
		"invite-others-to-connect-with": "Invite others to connect with {{name}}",
		"enter-emails-of-caregivers-you-want-connect": "Enter the email addresses of the {{caregivers}} or family members you would like to connect with {{name}}",
		"send-invitations": "Send invitations",
		"invitations-to-become-caregiver": "Invitations to become {{caregiver}}",
		"invitations-to-connect": "Invitations to connect",
		"cancel-invitation": "Cancel invitation?",
		"bravo-you-managed-create-account": "Congratulations! You have successfully created an account for {{name}}",
		"add-connection": "Add connection",
		"oops-look-like-you-dont-have-any-connections": "Oops! It looks like you don't have any connections.",
		"do-you-want-to-fill-information": "Would you like to provide more details about your {{care-recipient}} to help other {{caregivers}} better understand their needs?",
		"add-information": "Add information",
		"add-information-about-care-recipient": "Add {{care-recipient}} information",
		"create-account-for-care-recipient": "Create an account for a {{care-recipient}}",
		"thank-you-additional-information-is-helpful": "Thank you!\nAdditional information is always helpful!",
		"invite-family-members-to-be-connected-to": "Invite family members to be connected with {{ name }}.",
		"enter-the-email-addresses-of-the-family-members-that-youd-like-to-have-connected-to": "Enter the email addresses of the family members that you'd like to be connected with {{ name }}",
		"organisation-requests": "Organization requests",
		"request-accepted": "Request accepted",
		"care-receiver-is-now-part-of-the-organisation": "{{care-recipient}} is now part of the organization",
		"request-rejected": "Request denied",
		"temporary-access": "Temporary access",
		"transfer-name-to-organisation": "Transfer {{name}} to {{organisation}}"
	},
	"validations": {
		"error": "Error"
	},
	"profile": {
		"delete-profile-username-account": "Delete {{username}} account",
		"are-you-sure-you-want-to-delete-profile-username-account-forever": "Are you sure you want to delete {{username}}’s account forever?",
		"edit-profile": "Edit profile",
		"edit-information": "Edit information",
		"about-me": "About me",
		"old-password": "Old password",
		"new-password": "New password",
		"change-password": "Change password",
		"password-changed": "Password has been changed",
		"delete-account": "Delete account",
		"my-profile": "My profile",
		"saving-new-password": "Saving new password...",
		"saving-profile-photo": "Saving profile photo...",
		"saving-user-information": "Saving user information...",
		"show-activity": "Show Activity",
		"critical": "Critical",
		"positive": "Preferences",
		"negative": "Challenges",
		"add-information": "Add information",
		"send-message": "Chat",
		"connections": "Connections",
		"feed": "Feed",
		"about": "About",
		"create-a-folder": "Create a folder",
		"folder-name": "Folder name",
		"new-information-folder": "New Information Folder",
		"edit-information-folder": "Edit Information Folder",
		"remove-folder": "Remove a folder",
		"are-you-sure-remove-folder-name": "Are you sure you want to remove {{name}} information folder?",
		"add-folder-icon": "Add a folder icon",
		"edit-folder-icon": "Edit folder icon",
		"select-icon": "Select icon",
		"save-information": "Save information",
		"edit-folder": "Edit folder",
		"new-information": "New information",
		"add-information-icon": "Add information icon",
		"information-name": "Information name",
		"edit-information-icon": "Edit information icon",
		"remove-information": "Remove information",
		"are-you-sure-remove-information-name": "Are you sure you want to remove {{name}} information?",
		"there-is-no-information-yet": "There is no information yet.",
		"add-post-to-information": "Add a post to information",
		"there-are-no-posts-in-information": "There are no posts in information.",
		"create-information": "Create information",
		"create-subfolder": "Create subfolder",
		"delete-caregiver-confirm-title": "Disconnect {{careGiverName}}",
		"delete-caregiver-confirm-content": "Are you sure you want to remove {{careGiverName}} connection to {{careReceiverName}}?",
		"information-not-completed": "This {{care-recipient}} has incomplete information",
		"fill-information": "Complete information",
		"error-username-empty": "Username field cannot be empty",
		"error-firstname-lastname-empty": "First name and last name cannot be empty",
		"information": "Information",
		"improve-your-security-with-a-strong-password": "Improve your security with a strong password.",
		"repeat-new-password": "Repeat new password",
		"this-action-cannot-be-undone": "This action cannot be undone",
		"passwords-do-not-match": "Passwords do not match",
		"restricted-access": "Restricted Access",
		"restricted-access-description": "When disabled, user will be able to add posts and comments, like, edit and delete existing ones.",
		"not-authorized-to-view-profile": "You are not authorized to view this profile.",
		"would-you-like-to-invite-as-caregiver-for": "Would you like to invite {{careGiverName}} to become a {{caregiver}} for {{careReceiverName}}?",
		"invite": "Invite",
		"invitation-sent": "The invitation has been sent",
		"revoke": "Revoke",
		"revoke-invitation-confirm-title": "Revoke invitation?",
		"invitation-revoked": "Invitation has been revoked",
		"profile-saved": "Profile has been saved",
		"invite-to-become-caregiver": "Invite to become {{caregiver}}",
		"new-password-must-be-different-from-the-old-one": "New password must be different from the previous one",
		"invalid-password": "Invalid password",
		"folder-access": {
			"access": "Access",
			"set-access": "Set access",
			"access-to-the": "Access to the",
			"options": {
				"everyone": "Everyone",
				"description-everyone": "Every connected {{caregiver}} will have access to this",
				"everyone-in-organisation": "Everyone in the organization",
				"description-everyone-in-organisation": "All {{caregivers}} from {{ organisationName }} organization will have access to this",
				"individual-caregivers": "Individual {{caregivers}}",
				"description-individual-caregivers": "Only selected {{caregivers}} will have access to this"
			},
			"caregiver-list": "{{caregiver}} list",
			"no-caregivers-to-select": "No {{caregivers}} to select",
			"access-settings-saved": "Access settings saved",
			"target-information": "information",
			"target-folder": "folder"
		},
		"invite-caregivers": "Invite {{caregivers}}",
		"no-user-posts": "No user posts",
		"create-first-post-on-user-feed-to-get-started": "Create first post on user feed, to get started",
		"add-new-post": "Add new post",
		"access-to-profile-expires": "Access to this profile expires",
		"no-care-recipients-available": "No {{care-recipients}} available to select",
		"files": "Files",
		"files-table": {
			"name": "Name",
			"creator": "Creator",
			"created-at": "Created at",
			"download": "Download",
			"connected-care-recipients": "Connected {{care-recipients}}"
		}
	},
	"onboarding": {
		"complete-your-account-setup": "Complete your account setup",
		"what-is-your-name": "What is your name?",
		"first-name": "First name",
		"last-name": "Last name",
		"welcome-to-pletly-pal": "Welcome\n to Pletly Pal",
		"welcome-to-pletly-care": "Welcome\n to Pletly Care",
		"pletly-pal-is-the-platform-connecting-caregivers-and-facilitate-communication-with-care-receivers": "Discover how connected {{caregivers}} can make a significant difference in the lives of those they care for.",
		"add-phone-number": "Add a phone number",
		"by-adding-your-phone-number-you-are-providing-other-caregivers-an-option-to-contact-you-outside-the-pletly-ecosystem": "By providing your phone number, you are providing other Caregivers the option to contact you outside of the Pletly ecosystem",
		"add-connections": "Create or Connect a {{care-recipient}} Account",
		"create-new-account-for-a-care-receiver-or-connect-to-one-if-account-is-already-created": "Set up a new {{care-recipient}} account or connect to an existing one.",
		"create-account-for-care-receiver": "Create account for a {{care-recipient}}",
		"connect-with-existing-user": "Connect with existing user",
		"name-card-title": "Add your name",
		"name-card-description": "Please provide your first and last name. Your identity is important for ensuring effective communication.",
		"phone-card-title": "Add a phone number",
		"phone-card-description": "Providing us with your phone number will establish an additional means of communication when required.",
		"photo-card-title": "Add a profile photo",
		"photo-card-description": "Add photo, because you are beautiful!",
		"connect-card-title": "Connect to {{care-recipient}}",
		"connect-card-description": "To maximise the benefits of Pletly Pal, connect to one or more {{care-recipients}}.",
		"bio-card-title": "Complete your bio",
		"bio-card-description": "Tell others in the Pletly community a little about yourself.",
		"post-card-title": "Post something",
		"post-card-description": "Post information or media you'd like to share with other Caregivers in your {{care-recipient}}’s network.",
		"add-name": "Add name",
		"add-phone": "Add phone",
		"add-photo": "Add photo",
		"connect": "Connect",
		"add-bio": "Add bio",
		"add-post": "Add post",
		"edit-name": "Edit name",
		"edit-phone": "Edit phone",
		"edit-photo": "Edit photo",
		"connect-more": "Connect more",
		"edit-bio": "Add bio",
		"add-another-post": "Add another post",
		"complete-your-profile": "Complete Your profile",
		"congratulations": "Congratulations!",
		"your-profile-is-complete": "Your profile is complete!",
		"profile-completed": "Profile completed"
	},
	"lock": {
		"hello": "Hello",
		"use-fingerprint-to-login-to-your-account": "We prioritize the privacy of our {{care-recipients}}. Please re-authenticate to access Pletly Pal.",
		"or-just-use-password-instead": "or just use your password instead",
		"cant-unlock": "Can't unlock?"
	},
	"conversations": {
		"conversation-details": "Conversation details",
		"group-name": "Group name",
		"group-participants": "Participants",
		"edit-chat": "Edit chat",
		"add-chat": "Add chat",
		"chats": "Chats",
		"sending-private-message": "Sending private message...",
		"screen-title": "Messages",
		"my-chats": "My chats",
		"create-new-chat": "Create new chat",
		"create-group-chat": "Create group chat",
		"create": "Create",
		"type-message-here": "Type message here...",
		"messages-seen-by-name-on-when": "Messages seen by {{ name }} on {{ when }}",
		"report-message": "Report message",
		"edit-info": "To edit this group chat (add or remove participants, etc.), press the pencil icon in the top right corner.",
		"access-messages": "Access messages",
		"all-participants-in-the-chat-will-be-notified": "All participants in the chat will be notified.",
		"to-access-the-content-of-this-chat-click-the-button-below-all-participants-in-the-chat-will-be-notified": "To access the content of this chat, click the button below. All participants in the chat will be notified.",
		"are-you-sure-to-report-this-message": "Are you sure you want to report this message?",
		"you-will-not-see-this-message-anymore-and-we-will-review-your-report-shortly": "You will not see this message anymore and we will review your report shortly.",
		"are-you-sure-you-want-to-delete-this-conversation": "Are you sure you want to delete this conversation?",
		"failed-to-delete-conversation": "Failed to delete conversation",
		"no-results": "No results"
	},
	"menu": {
		"title": "Menu",
		"edit-profile": "Edit profile",
		"about-app": "About app",
		"settings-link": "Settings",
		"log-out": "Log out",
		"settings": {
			"title": "Settings",
			"notifications": {
				"title": "Notifications",
				"all-notifications": "All notifications",
				"new-post": "New post",
				"direct-message": "Direct message",
				"new-like-on-post": "New Like on post",
				"new-comment-on-post": "New comment on post"
			},
			"security": {
				"title": "Security",
				"master-lock": "Master lock",
				"lock-description": "Pletly Pal locks automatically after {{minutes}} minutes of inactivity and can be unlocked with TouchID, FaceID, or a passcode."
			}
		},
		"communities": "Communities",
		"switch-to-pletly-care": "Switch to Pletly Care",
		"switch-to-organisation-panel": "Switch to organization's panel",
		"my-files": "My files"
	},
	"verification": {
		"verify-email": "Verify Email",
		"an-email-has-been-sent-to": "An Email has been sent to",
		"please-click-on-link-to-verify-your-email-address": "Please click on the link to verify your email address",
		"resend-email": "Resend email",
		"sent-please-check-your-email": "Sent, please check your email",
		"your-email-has-been-successfully-verified": "Your email has been successfully verified."
	},
	"paywall": {
		"activate-premium": "Activate premium",
		"create-up-to-n-care-receivers-and-enjoy-unlimited-number-of-connections": "Create up to {{count}} {{care-recipients}} and enjoy an unlimited number of connections",
		"subscribe": "Subscribe",
		"maybe-later": "Maybe later",
		"you-can-cancel-your-subscription-at-anytime": "You can cancel your subscription at any time",
		"try-premium": "Try premium",
		"get-premium": "Get premium",
		"get-premium-and-enjoy-an-unlimited-number-of-connections": "Get premium and enjoy an unlimited number of connections",
		"get-started": "Get started",
		"for-the-first": "For the first",
		"then": "then",
		"periods": {
			"day_one": "day",
			"day_other": "{{count}} days",
			"week_one": "week",
			"week_other": "{{count}} weeks",
			"month_one": "month",
			"month_other": "{{count}} months",
			"year_one": "year",
			"year_other": "{{count}} years"
		}
	},
	"add-image": {
		"select-photo-from-gallery": "Select a photo from the gallery",
		"take-photo": "Take a photo",
		"record-video": "Record a video",
		"permission-to-access-camera-roll-is-required": "We need your permission to access the camera roll."
	},
	"header": {
		"home": "Home",
		"connections": "Connections",
		"notifications": "Notifications",
		"messages": "Chat",
		"search-for-connections": "Search for connections",
		"communities": "Communities",
		"ai": "AI"
	},
	"notifications": {
		"there-are-no-notifications": "There are no notifications.",
		"no-new-updates-right-now-youll-be-the-first-to-know-when-theres-something-new": "No new updates right now. You'll be the first to know when there's something new."
	},
	"community": {
		"create-new-community": "Create new community",
		"community-name": "Community Name",
		"add-name-here": "Add name here...",
		"community-description": "Community description",
		"add-description-here": "Add description here...",
		"privacy-settings": "Privacy settings",
		"pick-privacy-setting": "Set privacy setting",
		"members": "members",
		"make": "Make",
		"public": "Public",
		"private": "Private",
		"manage-members": "Manage members",
		"invite": "Invite",
		"leave": "Leave",
		"create-new-post": "Create new post",
		"join": "Join",
		"communities": "Communities",
		"explore": "Explore",
		"your-communities": "Your Communities",
		"invite-to-community": "Invite to community",
		"find-users-to-add": "Find users to add",
		"invite-users": "Invite users",
		"admins": "Admins",
		"community-members": "Community members",
		"add-post-to-the-community": "Add post to the community...",
		"join-owner": "Owner",
		"joined": "Joined",
		"change-group-visibility": "Change community visibility",
		"are-you-sure-you-want-to-make-this-group-privacy": "Are you sure you want to make this community {{privacy}}?",
		"community-you-belong-to": "Community you belong to",
		"invitations": "Invitations",
		"community-you-manage": "Community you manage",
		"group-visibility-updated": "Community visibility updated",
		"admin-removed": "Admin Removed",
		"join-request-sent": "Join request sent",
		"your-request-has-been-sent-to-the-community-owner": "Your request has been sent to the community owner",
		"leave-community": "Leave Community",
		"are-you-sure-you-want-to-leave-this-community": "Are you sure you want to leave this community?",
		"delete-community": "Delete community",
		"are-you-sure-you-want-to-delete": "Are you sure you want to delete {{ name }}?",
		"invites-sent": "Invites sent",
		"invite-removed": "Invite removed",
		"invited": "Invited",
		"admin-added": "Admin has been added",
		"member-removed": "Member has been removed",
		"remove-member": "Remove member",
		"are-you-sure-you-want-to-remove-member": "Are you sure you want to remove {{name}}?"
	},
	"summarization": {
		"summarize-posts": "Summarize posts",
		"select-dates": "Select dates",
		"select-from-date": "Select from date",
		"select-to-date": "Select to date",
		"generate-summary": "Generate posts summary",
		"from-date-until-date": "from {{fromDate}} until {{toDate}}",
		"posts-summary": "Posts summary",
		"generating-summary": "Generating summary...",
		"no-posts-to-summarize": "No posts to summarize for this period",
		"warning-text": "AI content may contain inaccuracies. Use your own judgment and verify important details.",
		"key-insights": "Key Insights",
		"suggestions": "Suggestions",
		"mood": "Mood"
	},
	"zod": {
		"only-letters-numbers-and-underscores-are-allowed": "Only letters, numbers, and underscores are allowed"
	},
	"no-information-folders": "No information folders",
	"create-your-first-folder-to-get-started": "Create your first folder to get started",
	"undo": "Undo",
	"edit-profile-form": {
		"receive-summary-notification-emails": "Receive summary emails"
	},
	"upload-new-file": "Upload new file"
}
